import { render, staticRenderFns } from "./PrizeFramePicture.vue?vue&type=template&id=a9cec4b6&scoped=true&"
import script from "./PrizeFramePicture.vue?vue&type=script&lang=js&"
export * from "./PrizeFramePicture.vue?vue&type=script&lang=js&"
import style0 from "./PrizeFramePicture.vue?vue&type=style&index=0&id=a9cec4b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cec4b6",
  null
  
)

export default component.exports